import { ButtonHTMLAttributes, ReactNode } from 'react';

type TableActionButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
};

/** Botão de texto na coluna Ações de tabelas. */
export function TableActionButton({
  type = 'button',
  className = '',
  children,
  ...props
}: TableActionButtonProps) {
  return (
    <button type={type} className={`erp-btn-table-action ${className}`.trim()} {...props}>
      {children}
    </button>
  );
}
